import 'bootstrap/dist/css/bootstrap.min.css';
import StandardButton from "../components/basic/StandardButton";
import styles from "../styles/main.module.css";
import {
    decryptAES256,
} from "../business/encryption/aes";
import {createFile, downloadFile} from "../utils/utils";
import {toast, ToastContainer} from "react-toastify";
import {fetchPasswordRecovery} from "../server-calls";
import StandardTextInput from "../components/basic/StandardTextInput";
import {useState} from "react";
import _ from "lodash";
import {useNavigation} from "../hooks/navigation";
import "react-toastify/dist/ReactToastify.css";

export default function AccountRecovery() {

    const TOAST_CONTAINER_ID= "accountRecovery-toast-container"

    const {redirect} = useNavigation()
    const [userEmail, setUserEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passphrase, setPassphrase] = useState("");
    const [recoverySuccess, setRecoverySuccess] = useState(false);


    const fetchCredentials = async () => {
        if (_.isEmpty(userEmail) || _.isEmpty(password)) {
            toast.error("Please enter a valid email address and recovery string.", {containerId: TOAST_CONTAINER_ID});
            return
        }
        toast.loading(`Running recovery`, {containerId: TOAST_CONTAINER_ID});
        let credentials = await fetchPasswordRecovery({email: userEmail});

        if (_.isEmpty(credentials)) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID});
            toast.error("Cannot find any recovery content for this account.", {containerId: TOAST_CONTAINER_ID});
            return
        }

        try {

            let decryptedString = decryptAES256(credentials, password);
            const [passphrase, privateKey] = decryptedString.split("___SEP___");
            setPassphrase(passphrase);
            setRecoverySuccess(true);
            downloadPrivateKey(privateKey)
        } catch (err) {
            console.error(err)
            toast.dismiss({containerId: TOAST_CONTAINER_ID});
            toast.error("The recovery string you entered is not correct.", {containerId: TOAST_CONTAINER_ID});
            return
        }


        toast.dismiss({containerId: TOAST_CONTAINER_ID});

        toast.success("Recovery success", {containerId: TOAST_CONTAINER_ID});
    }

    const downloadPrivateKey = (privateKey) => {
        const createdFile = createFile([privateKey], "text/plain")
        downloadFile(createdFile, `${userEmail}.key`)
    }

    const redirectToLoginPage = () => {
        redirect("/login")
    }


    return (
        <>
            <div className={styles.container}>
                <div style={{width: "400px"}}>
                    <h4>Password Recovery</h4><br></br>
                    <p>Please enter your recovery text and email address.</p><br></br>
                    <label><strong>Email</strong></label><br></br>
                    <StandardTextInput onChange={setUserEmail}/><br></br>
                    <label><strong>Recovery String</strong></label><br></br>
                    <StandardTextInput onChange={setPassword}/><br></br>
                    {!recoverySuccess && (
                        <StandardButton onClick={fetchCredentials} innerText={"Recover My Account"}/>)}
                    {recoverySuccess && (<StandardButton onClick={redirectToLoginPage} innerText={"To Login"}/>)}
                    <br></br><br></br>
                    {recoverySuccess && (
                        <p>Your passphrase is: {passphrase}</p>
                    )}
                </div>
            </div>
            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}